import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";

export default async function confirmCloseOutPortfolioParcision(pid: number) {
  try {
    const variables = { pid };

    const query = gql`
      query MyQuery($pid: Float!) {
        closeOutPortfolioParcision(pid: $pid) {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.closeOutPortfolioParcision;
  } catch (error) {
    toast.error("Failed to close out contract");
    sentryWrappedException(error);
    throw error;
  }
}
